import { Paragraph } from 'docx'
import {
  DraftQuestionnaireEntry,
  DraftTextCardItem
} from '../../data/model/questionnaire'
import { addMediaIfNeeded } from './addMediaUrlIfNeeded'
import { createMultilinedTextRuns } from './createMultilinedTextRuns'

export const createEntryContentTextCard = async (
  entry: DraftQuestionnaireEntry
): Promise<Paragraph[]> => {
  const entryItem = entry.entryItem as DraftTextCardItem
  // The "Add subtitle" switch writes to `body` and leaves `subtitle` empty, so
  // reading `subtitle` alone exported nothing. Kept as a fallback.
  const { body, subtitle } = entryItem.textCard
  const text = body || subtitle

  const paragraphs = text
    ? [
        new Paragraph({
          children: createMultilinedTextRuns(text)
        })
      ]
    : []

  await addMediaIfNeeded(entryItem, paragraphs)

  return paragraphs
}
